import { z } from 'zod';
import { emailValidationSchema } from '@/schemas/ValidationSchema.ts';

export const userCredentialsSchema = z.object({
  email: emailValidationSchema,
  password: z
    .string()
    .min(1, 'Hasło jest wymagane')
    .min(8, 'Hasło musi mieć co najmniej 8 znaków')
    .refine((val) => /[a-z]/.test(val), {
      message: 'Hasło musi zawierać co najmniej jedną małą literę',
    })
    .refine((val) => /[A-Z]/.test(val), {
      message: 'Hasło musi zawierać co najmniej jedną wielką literę',
    })
    .refine((val) => /\d/.test(val), {
      message: 'Hasło musi zawierać co najmniej jedną cyfrę',
    })
    .refine((val) => /[^a-zA-Z\d]/.test(val), {
      message: 'Hasło musi zawierać co najmniej jeden znak specjalny',
    }),
});

export type SignupFormData = z.infer<typeof userCredentialsSchema>;
